

<script>
  import ArticleDetail from '@/pc/pages/Article'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: ArticleDetail,
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .article_detail .con_wrapper {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 50px;
  }
  .article_detail .detail_top .data {
    padding-bottom: 22px;
    margin-bottom: 35px;
  }
  .article_detail .detail_top .subj {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.035em;
  }
  .article_detail .detail_top .date_area {
    font-size: 11.5px;
    margin-top: 20px;
    padding-top: 30px;
    position: relative;
    line-height: 1.6em;
  }
  .article_detail .detail_top .date_area .ctry_title {
    margin-right: 20px;
  }
  .article_detail .detail_top .date_area .date_latest {
    padding-left: 10px;
    margin-left: 10px;
    margin-right: 0;
  }
  .article_detail .detail_top .date_area .editor {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    margin-left: 0;
  }
  .article_detail .detail_top .date_area .editor .img {
    width: 22px;
    height: 22px;
  }
  .article_detail .detail_top .date_area .editor .name {
    padding-left: 7px;
  }
  .article_detail .detail_con .con_view {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.8em;
    padding-bottom: 50px;
  }
  .article_detail .detail_con .con_view a.btn_article {
    width: 100%;
    font-size: 1.0em;
  }
  .article_detail .detail_con .con_view a.btn_article:hover {
    background: #008c03;
  }
  .article_detail .detail_con .con_view .mv_ctnr {
    padding: 25px 20px;
    margin: 30px 0;
  }
  .article_detail .detail_con .con_view .mv_ctnr h5 {
    font-size: 18.5px;
    font-weight: 800;
  }
  .article_detail .detail_con .con_view .mv_coach {
    font-size: 12px;
    height: 166px;
    background-size: 160px auto;
    background-repeat: no-repeat;
    background-position: 51vw 100%;
    padding: 17px;
  }
  .article_detail .detail_con .con_view .mv_coach:before {
    width: 20px;
    height: 20px;
    top: 17px;
    right: 17px;
    left: unset;
    bottom: unset;
  }
  .article_detail .detail_con .con_view .mv_coach .name {
    font-size: 17px;
  }
  .article_detail .detail_con .con_view .mv_coach .name:before {
    font-size: 10px;
    margin-bottom: 9px;
  }
  .article_detail .detail_con .con_view .mv_coach ul {
    position: relative;
    top: 17px;
    right: unset;
  }
  .article_detail .detail_con .con_view .mv_coach ul li {
    margin-bottom: 8px;
  }
  .article_detail .detail_con .con_view .mv_coach ul li:before {
    width: 3px;
    height: 3px;
    margin-right: 5px;
  }
  .article_detail .detail_con .con_view .mv_coach em {
    font-size: 9px;
    left: 17px;
    bottom: 10px;
    right: unset;
  }
  .article_detail .detail_con .tag {
    position: relative;
    padding-left: 50px;
  }
  .article_detail .detail_con .tag .h_tags  {
    font-size: 13px;
    line-height: 1.0em;
  }
  .article_detail .detail_con .tag .h_tags .tit {
    font-weight: 700;
  }
  .article_detail .detail_con .tag .h_tags a {
    margin: 0 10px 12px;
  }

  .article_detail .detail_con .editor {
    padding: 25px 15px 25px 75px;
    font-size: 12px;
    margin: 25px 0;
    display: inline-flex;
    width: 100%;
    flex-direction: column;
  }
  .article_detail .detail_con .editor .img {
    position: absolute;
    top: 50%;
    left: 25px;
    transform: translate(0, -50%);
  }
  .article_detail .detail_con .editor .img img {
    width: 35px;
    height: 35px;
  }
  .article_detail .detail_con .editor p {
    margin: 0;
  }
  .article_detail .detail_con .editor p.name {
    align-self: flex-start;
  }
  .article_detail .detail_con .editor p.position {
    align-self: flex-start;
    max-width: 65%;
  }
  .article_detail .detail_con .editor a {
    right: 25px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .article_detail .detail_con .copy {
    line-height: 1.6em;
  }
  .article_detail .detail_con .copy span {
    display: block;
  }
  .article_detail .detail_con .telegram {
    padding: 15px 10px !important;
    margin: 20px 0 !important;
  }
  .article_detail .detail_con .telegram p {
    margin: 0 7px !important;
    line-height: 1.6em !important;
    font-size: 12px !important;
  }
  .article_detail .detail_con .telegram i.enter {
    display: block;
  }
  .article_detail .detail_con .telegram p {
    margin: 0 5px;
  }
  .article_detail .detail_con .telegram .img img {
    width: 36px;
    height: 36px;
  }
  .article_detail .detail_con .ad_article {
    width: 100vw;
    padding: 60px 20px 30px;
    margin: 40px 0 40px -20px;
  }
  .article_detail .detail_con .ad_article:before {
    font-size: 0.8em;
    font-weight: 500;
    padding: 9px 10px;
  }
  .article_detail .detail_con table {
    width: calc(100vw - 40px) !important;
    white-space: nowrap;
    overflow-x: scroll;
    display: block;
  }
  .article_detail .detail_con table tbody {
    display: table;
    width: 100%;
  }
  .article_detail .detail_con table td {
    padding: 12px 2.0vw;
    font-size: 0.80em;
  }
  .article_detail .detail_con table td:first-child {
    padding-left: 4vw;
  }
  .article_detail .detail_con table td:last-child {
    padding-right: 4vw;
  }
  .article_detail .detail_con p.box {
    padding: 15px 20px;
  }
  .article_detail .related_con .title {
    margin: 15px 0;
    width: 100%;
  }
  .article_detail .related_con h3 {
    font-size: 18px;
    line-height: 1.8em;
  }
  .article_detail .related_con h3:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .article_detail .related_con .lst > li {
    width: 100% !important;
    min-height: unset !important;
    padding: 0 !important;
    margin-bottom: 30px !important;
    border-right: 0 !important;
    border-bottom: none !important;
  }
  .article_detail .related_con .lst > li:nth-child(3n+1) {
    padding: 0 !important;
    width: 100% !important;
  }
  .article_detail .related_con .lst > li:nth-child(3n+3) {
    padding: 0 !important;
    width: 100% !important;
    border-right: none !important;
  }
  .article_detail .related_con .lst > li a {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .article_detail .related_con .lst > li .img {
    height: 58vw;
  }
  .article_detail .related_con .lst > li .category {
    font-size: 12px;
    margin-top: 10px;
    order: 2;
  }
  .article_detail .related_con .lst > li .subj {
    font-size: 17px;
    margin-top: 17px;
    order: 1;
  }
  .article_detail .related_con .lst > li a:hover .subj {
    color: #379339;
  }
  .article_detail .list_btn {
    width: 100%;
    margin: 20px auto 50px;
    font-size: 16px;
    letter-spacing: -0.03em;
  }
</style>
